import { render, staticRenderFns } from "./SingleBudgetProgramField.vue?vue&type=template&id=42b370e8&"
import script from "./SingleBudgetProgramField.vue?vue&type=script&lang=ts&"
export * from "./SingleBudgetProgramField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports